import { AsyncPipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet } from "@angular/material/bottom-sheet";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { CommonVariable } from "src/app/app.constants";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { MarketingCampaignsService } from "src/app/services/marketing-campaigns.service";
@Component({
  selector: "app-referral-modal",
  templateUrl: "./referral-modal.component.html",
  styleUrls: ["./referral-modal.component.scss"],
  standalone: true,
  imports: [
    IonicModule,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class ReferralModalComponent implements OnInit {
  mgm$: any;
  selectedLanguage: string = "en";
  public preferredCurrency: string;
  public currencySymbol: string = CommonVariable.defaultCurrencySymbol;
  public intMoreInfoDetails;
  constructor(
    private bottomSheet: MatBottomSheet,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    public translate: TranslateService,
    private authService: AuthService,
    private GTMSegment: GTMSegmentService,
    private marketingCampaignsService: MarketingCampaignsService,
  ) {
    this.preferredCurrency = CommonVariable.preferredCurrency;
    this.currencySymbol = CommonVariable.defaultCurrencySymbol;
    this.intMoreInfoDetails = [];
    this.GTMSegment.GTMPopupInitialization("ReferralModelComponent");
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l ? l : "en";
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
    this.authService.userDetails$?.subscribe((user) => {
      this.preferredCurrency = user?.preferred_currency ?? CommonVariable.preferredCurrency;
      this.authService.getCurrencyList$?.subscribe((data: Data) => {
        const CurrencyDetails = data?.details?.find((x) => x?.currency_code === this.preferredCurrency);
        this.currencySymbol = CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;
      });
    }, (err) => { return err; });
    this.marketingCampaignsService.getMGMDetails()?.subscribe(async (mgm) => {
      if (mgm?.int_more_info_detail) {
        const selectedLanguageOrDefault = this.selectedLanguage || 'en';
        const moreInfoDetail = mgm?.int_more_info_detail?.[selectedLanguageOrDefault];
        if (!moreInfoDetail) {
          return;
        }
        try {
          for (const desc of moreInfoDetail) {
            const value = (await this.authService.getDVFromString(desc)) || "";
            this.intMoreInfoDetails.push(value);
          }
        } catch (error) {
          return error;
        }
      }

    })

    this.mgm$ = data;
  }

  ngOnInit() { }

  backToMgm() {
    this.bottomSheet.dismiss();
  }
}
